"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var color = function (_color) { return "color: " + _color + ";"; };
exports.default = (function () { return function (_a) {
    var theme = _a.theme;
    return color(theme.palette.inputTextColor[0]);
}; });
